module.exports = __webpack_public_path__ + "static/media/Stephanie W.070817cd.png";